import React, { useState, useEffect, useMemo } from "react";
import { Col, Card, CardBody, Button } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import { getRecords } from "../../services/api.service";
import TableContainer from "../../components/Common/TableContainer";

const ScrabApproval = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [isFetch, setIsFetch] = useState(false);
  const skeletonStyle = {
    backgroundColor: "#f0f0f0",
    borderRadius: "4px",
    position: "relative",
    overflow: "hidden",
    background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
    backgroundSize: "200% 100%",
    animation: "shimmer 1.5s infinite linear",
  };

  useEffect(() => {
    let timer;

    const fetchData = async () => {
      if (!isFetch) {
        await getData();
      }
    };

    timer = setTimeout(fetchData, 500);

    const handleStorageChange = () => {
      getData();
      setIsFetch(true);
    };

    window.addEventListener("dashboardUpdate", handleStorageChange);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("dashboardUpdate", handleStorageChange);
    };
  }, [isFetch, page, pageSize]);

  const getData = async () => {
    const contractorId = JSON.parse(localStorage.getItem("userDetails"))?.id;
    let dashboard_details = JSON.parse(
      localStorage.getItem("dashboard_details")
    );
    if (!dashboard_details || !contractorId) return;
    try {
      setIsLoading(true);

      const payload = {
        modelName: "outwards",
        whereCondition: {
          type: "Scrab",
          project_id: {
            in: dashboard_details?.project_id,
          },
          contractor_id: contractorId,
          scrab_status: "Pending",
        },
        relations: [
          { module: "outward_items", moduleAs: "outward_items" },
          { module: "projects", moduleAs: "project" },
          { module: "user_masters", moduleAs: "customer" },
          { module: "warehouse_masters", moduleAs: "warehouse" },
          { module: "user_masters", moduleAs: "contractor" },
          { module: "user_masters", moduleAs: "createdBy" },
        ],
        search: {
          searchKeyword: searchKeyword,
          field_name: ["warehouse.warehouse_name", "contractor.first_name"],
        },
        pagination: {
          page: page + 1,
          pageSize: pageSize,
        },
      };

      const responseData = await getRecords(payload, "/getRecords");
      if (responseData.data.length > 0) {
        responseData.data.forEach((element, index) => {
          element.index = index + 1;
        });
        setTotalCount(responseData.count);

        const sortedData = responseData.data.sort((a, b) => b.index - a.index);
        setData(sortedData);
      } else {
        setData([]);
        setTotalCount(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDetails = (fromDashboard) => {
    navigate(`/scrap-approval-list`, {
      state: { fromDashboard },
    });
  };

  if (data.length === 0) return null;

  return (
    <Col>
      <style>
        {`
              @keyframes shimmer {
                to { background-position: -200% 0; }
              }
            `}
      </style>

      {isLoading ? (
        <Col>
          <Card>
            <CardBody>
              <div className="d-flex">
                <div className="flex-1 overflow-hidden">
                  <div
                    style={{
                      ...skeletonStyle,
                      width: "150px",
                      height: "20px",
                      marginBottom: "12px",
                    }}
                  />
                  <div
                    style={{
                      ...skeletonStyle,
                      width: "80px",
                      height: "24px",
                    }}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-end">
                <div
                  style={{
                    ...skeletonStyle,
                    width: "80px",
                    height: "20px",
                  }}
                />
              </div>
            </CardBody>
          </Card>
        </Col>
      ) : (
        <Col>
          <Card>
            <CardBody>
              <div className="d-flex">
                <div className="flex-1 overflow-hidden">
                  <p className="text-truncate font-size-14 mb-3 fw-bold">
                    No of scrap Approvals (No.)
                  </p>
                  <h4 className="mb-0"> {data?.length}</h4>
                </div>
              </div>
              <div className="d-flex justify-content-end">
                <Button
                  color="link"
                  className="d-flex align-items-center justify-content-center fw-bold p-0 text-decoration-none"
                  onClick={() => handleDetails(true)}
                >
                  Details
                  <i className="ri-arrow-right-line fs-5 ms-1"></i>
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      )}
    </Col>
  );
};

export default ScrabApproval;
